import React from 'react'
import { analytics } from 'Modules/Analytics'
import { initiatives } from 'Modules/Analytics/trackActionInterface/Impact/Initiatives'
import { useAppState } from 'Context/AppContext/AppContext'
import { Modal } from '@material-ui/core'
import { Button } from '@resiliatech/birdsong'
import {
  DeleteChartContentContainer,
  FlexRowColumn,
  ChartModalButtonContainer,
  ChartModalHeader,
  Text,
} from './ChartMenu.styled'

type DeleteTaskModalProps = {
  isOpen: boolean
  onClose: () => void
  onDeleteChart: () => void
}

export const DeleteChartModal = ({
  isOpen,
  onClose,
  onDeleteChart,
}: DeleteTaskModalProps) => {
  const {
    nonprofitOrgConfig: { role, nonprofitOrgRole },
  } = useAppState()
  const handleDeleteChart = async () => {
    analytics.trackActionCreator(initiatives.Goal_Chart_Delete_Submitted)({
      role,
      relationship: nonprofitOrgRole,
    })
    onDeleteChart()
    onClose()
  }
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disableEnforceFocus
    >
      <DeleteChartContentContainer>
        <ChartModalHeader>Delete Data</ChartModalHeader>
        <FlexRowColumn>
          <Text>Are you sure you want to delete all your data points?</Text>
          <Text>
            All your current data will be deleted and your chart will be empty
            until you choose to start a new one.
          </Text>
        </FlexRowColumn>
        <ChartModalButtonContainer>
          <Button
            label='Cancel'
            onClick={onClose}
            type='button'
            variant='tertiary'
          />
          <Button
            label='Delete'
            onClick={handleDeleteChart}
            type='button'
            variant='primary'
          />
        </ChartModalButtonContainer>
      </DeleteChartContentContainer>
    </Modal>
  )
}
